const Breakpoints = {
  mobile: 767,
  tablet: 1025,
  desktop: 1440
}

export default Breakpoints
